export const searchProductGQL = /* GraphQL */ `
  query searchProductStatusV2(
    $currentFilter: SearchProductFilterInput
    $previousFilter: SearchProductFilterInput
    $aggregates: [SearchableProductAggregationInput]
  ) {
    searchCurrentProducts: searchProductStatusV2(
      filter: $currentFilter
      aggregates: $aggregates
    ) {
      currentItems: aggregateItems {
        name
        type
        result {
          buckets {
            key
            doc_count
          }
        }
      }
    }
    searchPreviousProducts: searchProductStatusV2(
      filter: $previousFilter
      aggregates: $aggregates
    ) {
      previousItems: aggregateItems {
        name
        type
        result {
          buckets {
            key
            doc_count
          }
        }
      }
    }
  }
`

export const hydrateMapGQL = /* GraphQL */ `
  query searchProductStatusV2(
    $location: LocationInput
    $distance: Int
    $filter: SearchProductFilterInput
    $aggregates: [SearchableProductAggregationInput]
  ) {
    searchProductStatusV2: searchProductStatusV2(
      location: $location
      distance: $distance
      filter: $filter
      aggregates: $aggregates
    ) {
      aggregateItems {
        name
        type
        result {
          buckets {
            key
            doc_count
          }
        }
      }
      total
    }
  }
`
